import patchNotes from '../../data/patchNotes';
import Modal from './Modal';

export default function PatchNotesModal({ onClose }) {
    return (
        <Modal title="🚀 Nouveautés & fonctionnalités" onClose={onClose}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '60vh', overflowY: 'auto' }}>
                {patchNotes.map((note, i) => (
                    <div key={i} style={{
                        backgroundColor: '#f8fafc',
                        borderRadius: '8px',
                        padding: '12px 14px',
                        borderLeft: `3px solid ${note.status === 'done' ? '#16a34a' : '#f59e0b'}`,
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            <span style={{
                                fontSize: '11px',
                                fontWeight: '700',
                                padding: '2px 8px',
                                borderRadius: '20px',
                                backgroundColor: note.status === 'done' ? '#dcfce7' : '#fef3c7',
                                color: note.status === 'done' ? '#16a34a' : '#d97706',
                            }}>
                                {note.status === 'done' ? '✅ Livré' : '🚧 En cours'}
                            </span>
                            <span style={{ fontSize: '11px', color: '#aaa' }}>
                                {new Date(note.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                            </span>
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '700', color: '#1a1a2e', marginBottom: '2px' }}>
                            {note.title}
                        </div>
                        <div style={{ fontSize: '13px', color: '#666' }}>
                            {note.description}
                        </div>
                    </div>
                ))}
                {patchNotes.length === 0 && (
                    <div style={{ textAlign: 'center', color: '#888', padding: '24px' }}>
                        Aucune note pour le moment
                    </div>
                )}
            </div>
        </Modal>
    );
}